import { Vector3 } from 'three';
import { data } from './data';

export const cameraLookAtVec = new Vector3(
    data[1].cameraLookAt.x,
    data[1].cameraLookAt.y,
    data[1].cameraLookAt.z,
);
